import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';

var standardStyles = {
  display: 'block',
  color: 'text',
  whiteSpace: 'pre-wrap',
  variant: 'scrollbar.text-area'
};
var disabledStyles = {
  '[disabled]': {
    cursor: 'not-allowed',
    backgroundColor: 'neutral.light',
    color: 'neutrals.15',
    '::selection': {
      color: 'none',
      background: 'none'
    },
    '::placeholder': {
      color: 'neutrals.11' //neutral.dark
    }
  }
};
var focusStyles = {
  zIndex: '2'
};
var hoverStyles = {
  zIndex: '2',
  borderColor: 'black'
};
var placeholderStyles = {
  '::placeholder': {
    color: 'neutral.darker'
  }
};
var readOnlyStyles = {
  ':read-only': {
    cursor: 'text',
    backgroundColor: 'neutral.light'
  }
};
var textarea = {
  "default": function _default(_theme, props) {
    var state = props.state,
      resize = props.resize;
    return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      resize: resize
    }, standardStyles), placeholderStyles), disabledStyles), readOnlyStyles), {}, {
      border: '1px solid',
      borderColor: state ? state : 'neutrals.15',
      ':focus:not(:read-only)': _objectSpread2(_objectSpread2({}, focusStyles), {}, {
        borderColor: state ? state : 'primary',
        boxShadow: state ? state : 'primary'
      }),
      ':hover:not([disabled]):not(:focus):not(:read-only)': _objectSpread2({}, hoverStyles)
    });
  }
};

export default textarea;
//# sourceMappingURL=textarea.esm.js.map
